import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BuyButton from '@/components/BuyButton.vue';
import Frame from '@/components/Frame.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ClaimBuyOnlyBody',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Frame, { class: "m-project" }, {
    default: _withCtx(() => [
      _createVNode(BuyButton)
    ]),
    _: 1
  }))
}
}

})